import enLocale from "element-ui/lib/locale/lang/en";
const en = {
  Topic: {
    articlelist: {
      msg: `Topic`,
      all: `All`,
      title: `Editor's picks`,
      HotList: `Trending Topics`
    },
    articleview: {
      MSG: `Posted`,
      Collection: "Bookmark",
      share: `Share`,
      sgL_ReprintedSourceTitle: `Reprint Source:`,
      Type: `Type:`,
      key: `Key Words:`,
      might: `You may also like`
    }
  },
  message: {
    operatesuccessfully: "The Operation Succeeded.",
    operationfailure: "Operation Failed",
    not_found: "The Data Was Not Found",
    server_error: "Server Error",
    Request_parameter_error: "Request Parameter Error",
    Interface_address_error: "Interface Address Error",
    information: "Login Information Has Expired, Please Login Again",
    permission: "Do Not Have Permission, Please Contact The Administrator",
    server_timed_out: "Connection To Server Timed Out",
    have_no_right: "Have No Authority",
    path_not_found: "The Requested Path Was Not Found"
  },
  login: {
    title: "this title",
    username: "Please enter the user name",
    password: "Please enter your password"
  },
  Index: {
    SelectedFilms: `Selected Films`,
    more: `More`,
    FeedCloud: `Find Treasure Cloud video`,
    Copylinks: `Copy Links`,
    bookmark: "Bookmark",
    share: `Sharing`,
    flag: `Report`,
    albumHotList: `Album of the Week`,
    eventList: `Recent shooting Activities`,
    HotList: `Hot News`,
    albumList: `Top Albums`,
    articleList: `Hot Topics`
  },
  Activitys: {
    ActiveList: {
      msg: `Activity List`,
      favor: "Bookmark",
      sgL_ActivityDateF: `Date`,
      KMKeywor: `Activity Name`,
      sum: `Common`,
      photoCount: `Album`,
      sgL_TypeF: `Types`,
      sgL_AreaF: `Location`,
      sgL_StatusF: `Registration Status`,
      msg2: `List of Past Activities`,
      screen: `Screening`,
      activitydate: `Date of Event`,
      startdate: `Start Date`,
      enddate: `End Date`,
      city: `City of Residence`,
      placeholder: `Please select a city`,
      type: `Activity type`,
      remark: `Notes on Activities`,
      refresh: `Reset`,
      SendMessage: `Provide new event information`
    },
    Activeview: {
      share: `Share`,
      sgL_ActivityDatesF: `Activity Date`,
      sgL_Address: `Venue`,
      sgL_KMKeyworldF: `Event Ttems`,
      sgL_UnitTitle: `Organizer`,
      sgL_StatusF: `Registration Status`,
      sgL_EndApplyDateF: `Application Deadline`,
      sglActivityUrl: `Event Website`,
      sglActivityUrl2: `Other Links`,
      EventAlbum: `Event Album`,
      msg: `Events with similar dates`
    },
    profileBookmarkEvent: {
      msg1: `Past activities`,
      msg2: `Date`,
      msg3: `Activity Name`,
      msg4: `Types`,
      msg5: `Location`,
      msg6: `Registration status`,
      msg7: `Unbookmark`,
      msg8: `2019/06/17 (day)`,
      msg9: `Ancient Road along the Mountain under Ailiao (Young Horse) [Double Day Race]`,
      msg10: `21K,10K,5K`,
      msg11: `Road running`,
      msg12: `New Taipei City`,
      msg13: `Registration closed`,
      msg14: `2018/05/04 (day)`,
      msg15: `2020 South Zeng - The 3rd 800 Heroes Super Horse Series`,
      msg16: `10K,Children's Section`,
      msg17: `Bicycle`,
      msg18: `New Taipei City`,
      msg19: `Registration closed`,
      msg20: `2016/10/24 (day)`,
      msg21: `Parent-child group, adult group`,
      msg22: `Bicycle`,
      msg23: `New Taipei City`,
      msg24: `Registration closed`,
      msg25: `Future Activities`,
      msg26: `05/17 (day)`,
      msg27: `06/22 (day)`,
      msg28: `3/23 Sign up`,
      msg29: `07/14 (day)`
    },
    SendMessage: {
      information: `Provide event information`,
      activities: `You are welcome to provide us with information about sports activities. We will publish the information on our website as soon as possible`,
      Activitylist: `Activity list`,
      on: `Up.`,
      ActivityName: `Activity Name`,
      activityType: `Activity Type (Multiple options)`,
      activityUrl: `Event Website`,
      area: `Place of Activity`,
      sgL_City: `Please select region`,
      sgL_Area: `Please select the city`,
      sgL_Address: `Full Address`,
      placeholder: `Detailed Location`,
      activityData: `Activity Date`,
      msg: `-`,
      startdate: `Start Date`,
      enddate: `End Date`,
      submit: `Submit`,
      activityStartData: `Date of Registration`,
      activerules: {
        title: `Please enter the activity name`,
        activityType: `Please enter the activity type`,
        activityUrl: `Please enter the activity link`
      }
    }
  },
  header: {
    albumIndex: "Photo Album",
    eventList: "Activity",
    blog: "Blog",
    articleList: "Topic",
    VideoIndex: "Audio & Video",
    title: "Scavenger Net",
    search: "Search",
    uploadImage: "Upload photos/create an Album",
    customerPublish: "Profile Page",
    feed: "Dynamic Feed",
    mobile: "Live Broadcast",
    admin: "Administrator",
    loginout: "Log Out",
    notlogin: "Not logged in",
    cusLogin: "Log in",
    customerInfo: "Check my personal file",
    MoreProgram: "Our program",
    Activity: "Activity Page",
    Citizen: "The best Citizen Ride 5K",
    Latestnotice: "Latest notice",
    copyright: "Copyright © 2021. SOONNET.org. All rights reserved",
    Uploadphotos: "Upload Photos Or Albums",
    Uploadshortvideos: "Upload Short Videos",
    Publishblogposts: "Publish Blog Posts",
    Checkprofile: "Check out My Profile",
    Websitelanguage: "Website language",
    TraditionalChinese: "Traditional Chinese",
    Officialchannel: "Official Channel",
    Liveevent: "Live Streaming",
    Exclusiveprogram: "Exclusive Program",
    CommunityDynamics: "Community Dynamics",
    RecentSearches: "Recent Searches",
    Checkprofile_: "All Categories",
    EventInformation: "Event Information"
  },
  Album: {
    albumIndex: {
      type: "Type",
      Hot: "Top of the week",
      more: "More",
      Latestupload: "Latest Upload",
      Uploadphotos: "Upload Photos",
      Ranking: "Photographer Ranking",
      Ranking_: "Ranking",
      photographer: "Photographer",
      Collection: "Collection of the week",
      Compilationtitle: "Compilation Title",
      Numberalbums: "Number of Albums"
    },
    albumList: {
      Photoalbumlist: "Photo Album List",
      all: "All",
      sorting: "Sort By:",
      orderbyhot: "Last Update",
      Bypopularity: "By Popularity"
    },
    albumviewDetail: {},
    albumviewFaceRecognition: {
      Uploadfacial: "Upload Facial Photos for Search",
      Uploadtitle:
        "Click the plus sign on the top to add a profile picture to search for, and press the button on the bottom to search for a face.",
      Upload: "Face search instructions",
      facesearch: "Conduct a face search",
      Startfacesearch: "Start a face search"
    },
    albumviewPhoto: {
      startdate: "Start time",
      enddate: "End time",
      Bibsearch: "Bib search",
      Facesearchphotograph: "Face search photograph",
      sorting: "Sort by:",
      orderbyhot: "Last Update",
      Bypopularity: "By Popularity",
      browse: "Browse",
      collect: "Collect",
      DownloadHD: "Download (HD compression)",
      Downloadlossless: "Download (Original Lossless)",
      prevtext: "Previous Page",
      nexttext: "Next Page",
      Clicktogo: "Click to go",
      textcontent: 'Click "Like" or "Favorite" to log in first',
      Login: "Log In",
      title: "Title",
      Lastpage: "Last Picture",
      nextpage: "Next Slide"
    },
    albumviewPhotoolds: {
      browse: "Browse",
      collect: "Collect",
      DownloadHD: "Download (HD compression)",
      Downloadlossless: "Download (original lossless)",
      Photo: "Photograph",
      copy: "Copy",
      good: "Good",
      share: "Share",
      accuse: "Inform Against",
      Photoalbum: "Photo Album List",
      photoDetail: "Album Description and Message",
      Albumdescription: "Album Description",
      CShootTimerF: "Date of Shooting:",
      CAddTimerF: "Date of Upload:",
      CMasterSortStr: "Type:",
      shortWebUrl: "Short Link:",
      keyword: "Key Words:",
      leaveword: "Leave a Message",
      startdate: "Start Time",
      enddate: "End Time",
      Bibsearch: "Bib Search",
      Facesearch: "Face Search Photograph",
      AuthCheck: "Find Unrecognized Photos",
      identified: "Identified ",
      piece: " Piece",
      unrecognized: "Unrecognized",
      unidentifiable: "Unrecognizable",
      update: "Edit/Add",
      delete: "Delete Album",
      sorting: "Sort By:",
      orderbyhot: "Last Update",
      Bypopularity: "By Popularity",
      Clicktogo: "Click to Go",
      prevtext: "Previous Page",
      nexttext: "Next Page",
      textcontent: 'Click "Like" or "Favorite" to log in first',
      Login: "Log In",
      title: "Title",
      Lastpage: "Last Picture",
      nextpage: "Next Slide",
      asc: "-(Asc)",
      desc: "-(Decs)"
    },
    albumviewPhotostreamItem: {
      viewcount: "Browsing Times"
    },
    collection: {
      Bibsearch: "Bib Search",
      Collectionintroduction: "Collection Description",
      Lastupdatetime: "Last Update"
    },
    collectionlist: {
      Setlist: "Collection list"
    },
    photoview: {
      Lastpage: "Last Picture",
      nextpage: "Next Slide",
      DownloadHD: "Download (HD compression)",
      Downloadlossless: "Download (original lossless)",
      Returnalbum: "Return to Album",
      Slideshow: "Slide Show",
      del: "Delete",
      good: "Good",
      share: "Share",
      collect: "Collect",
      Download: "Download",
      shortWebUrl: "Short URL",
      copy: "Copy",
      view: "View",
      leaveword: "Leave a Message",
      Cameramanufacturer: "Camera Manufacturer",
      Cameratype: "Camera Type",
      size: "Size",
      Dateshooting: "Date of Shooting",
      aperture: "Aperture",
      exposure: "Exposure",
      Focallength: "Focal Length",
      Luminancevalue: "Luminance Value",
      Exposurecompensation: "Exposure Compensation",
      sensitivity: "ISO Sensitivity",
      flashlight: "Flash Lamp",
      Exposureprogram: "Exposure Program",
      Photometricmode: "Photometric Mode"
    },
    singleCollection: {},
    uploadImage: {
      Selectpicture: "Select Picture",
      uploading: "Upload",
      complete: "Complete",
      Uploadandsave: "Upload and Save",
      the: "Then",
      failed: "th picture failed to be uploaded",
      filehere: " Drag the file here",
      or: " or",
      ClickuploadFile: " Click Upload File",
      uploadfiles: " You can only upload jpg/png files",
      Waitfor: " Wait for",
      pictures: " Pictures",
      pleasefeel:
        " In order to optimize the upload speed of users, some uploaded pictures will be hidden, please feel free to click upload.",
      use: "Recommended Use",
      Google: "Google Chrome",
      upload: "Upload",
      and:
        "The website reserves the right to remove unauthorized or unauthorized photos without notice",
      piece: "Piece",
      Uploadprogress: "Upload Progress",
      Photocount: "Photo Count",
      Uploadedphoto: "Uploaded Photo",
      Currentrate: "Current Rate",
      Timespent: "Time Spent",
      Estimatedtime: "Estimated time of completion",
      uploadings: "Uploading",
      Addphoto: "Add Photo",
      Deleteentire: "Delete Entire Page",
      Deleteall: "Delete All",
      Compactphoto: "Compact photo album (recommended size: 450*450 or above)",
      title: "Album Title",
      description: "Album Description",
      keyword: `Keywords (separated by ', 'without Spaces)`,
      type: "Album Type",
      time: "Date of Shooting",
      active: "Associated Activity",
      notnull: "Nothing",
      date: "Date",
      activeDate: "Event Date",
      activeplaceholder: "Please Select an Event Date",
      activeId: "Activity",
      set: "Privacy Setting",
      open: "Make Public",
      notopen: "Private. Only you can see it",
      ShareEXIF: "Share the EXIF message of each photo you take",
      Include: "Include camera model, aperture, shutter, etc",
      hide: "Hide",
      keywordplaceholder: "e.g. Standard Chartered Marathon,2021",
      dialogFormVisible:
        "You have uploaded but unsaved photos that can be reloaded",
      dtl: "Note: Only keep albums that have not been saved within 3 days",
      del: "Delete",
      cancle: "Cancellation",
      submit: "Confirm",
      sectionTitle: "Create an Album",
      EditsectionTitle: "Edit Photo Album",
      Editdomtitle: "Edit photo album. - Treasure Hunt",
      Uploaddomtitle: "Upload a photo. - Treasure Hunt",
      albumRule: {
        title: "Please enter the name of the album",
        time: "Please enter the time",
        type: "Please enter the album type"
      }
    },
    VRanking: {
      Ranking: "Photographer Ranking",
      Mostviewed: "Most Viewed",
      Numberofclicks: "Number of Click",
      photographer: "Photographer",
      Mostuploaded: "Most Uploaded",
      Numberphotographs: "Number of Photographs",
      Mostdownloaded: "Most Downloaded",
      Numberdownloads: "Number of Downloads",
      largestcollection: "The Largest Collection",
      collections: "Number of Collections"
    }
  },
  blog: {
    all: {},
    cardList: {
      new: "Latest Release",
      Topbrowse: "Top Browse"
    },
    category: {},
    content: {
      Unsubscribe: `Unsubscribe`,
      Subscribe: `Subscribe`,
      Hidepost: `Hidden post`,
      Display: `Display post`,
      author: "Author",
      Subscribernumber: "Subscriber count",
      authorhighest: "Author's most viewed post",
      Popularpost: "Popular Post",
      subscriber: "Subscriber",
      Editpost: "Edit",
      Delpost: "Delete",
      Releasetime: "Publishing time",
      copy: "Copy",
      good: "Good",
      share: "Share",
      collect: "Collect",
      report: "Report",
      Reproducedsource: "Reproduced Source:",
      Keywords: "Key Words:",
      blognotes:
        "The content of the blog is a platform for netizens to exchange experiences. The above content does not represent the position of treasure hunting network",
      Last: "Last Post",
      Next: "Next Post",
      Leave: "Leave a Message",
      Editmessage: "Edit Message",
      Delmessage: "Delete Message",
      Leavemessage: "Leave Message",
      Leaveplaceholder: "Enter your Message",
      Haircloth: "Hair Cloth",
      Subscribed: "Subscriber",
      title: "Title",
      upPost: "Modify Message",
      Confirmsubmission: "Confirm Submission"
    },
    index: {},
    menu: {
      placeholder: "Please Select"
    },
    userInfo: {
      Briefintroduction: "Brief Introduction",
      Subscribernumber: "Subscriber Number",
      Subscriber: " Subscribe to Read",
      authorhighest: "Author's most viewed post",
      blong: "Weblog"
    }
  },
  common: {
    about: {
      t1: "About Us",
      t2:
        "We, focus on creating the most immediate movement in sports events. Provide immersive professional quality video, photos and other services, complete connection sports fans of the new media network.",
      t3: `SOONNET
            Starting from "Sports events", focus on creating pictures/video reports of various events, so that you are not present, but you are there, cheering for the racers...`,
      t4: `We are an interactive platform for sharing dynamic life. Every day, our members share sports-related people and events, including sports, sports, health, entertainment, products, scenery and other professional content, through the website and social media. We co-organise a series of events and sports promotion activities every month to spread this non-mainstream life attitude to all walks of life in the Asia-Pacific region.`,
      t5: `We are committed to the study of the Internet and new media, focusing on the model innovation and business practice of social network for the sports industry.`,
      t6: `Our solutions cover market research, marketing, customer maintenance, e-commerce and media communication.`,
      t7: `So far, it is the most complete new network media solution provider for the sports industry in Asia Pacific.`,
      "t7-2": `Our mission`,
      t8: ` Help sports lovers /
            The participants build an interactive bridge with various enterprises in the sports industry to achieve multi-win.`,
      t9: `  Help sports lovers /
            Participants find suitable sports products and carry out comprehensive direct marketing B2B2C and O2M.`,
      t10: `Help sports industry enterprises to establish their own brands, promote comprehensive market development.`,
      t11: `Help sports lovers /
            Participants build environmental awareness with various companies in the sports industry and implement comprehensive environmental programmes.`,
      t12: `Our advantage`,
      t13: `1.
            Based on Hong Kong and Taiwan, back to the mainland of China, to the Asia-Pacific region development, to become a bridge between mainland China and the international connection.`,
      t14: `2. New network media solution providers for the sports industry.`,
      t15: `3. For sports industry social network marketing service providers.`,
      t16: `4. The service provider that brings sports industry direct marketing into sports industry.`,
      t17: `5. Integrate the sports industry and provide B2B2C/O2M.`,
      t18: `6. A service provider that combines environmental awareness with online media.`
    },
    advertise: {
      Advertisingcooperation: "Advertising Cooperation",
      Advertisinginquiry: "Advertising Cnquiry",
      t1:
        "If you have any enquiries about advertisement placement and exposure, please contact us:",
      Current: "Current advertising format",
      JPG: ` All image advertising formats support JPG/PNG/GIF, and the recommended upper file size is 2
            MB.`,
      MP4: `  All video AD formats support MP4 / MOV, and the recommended file size is 1280x720px
            Or below. The recommended maximum file size is 20 MB.`,
      code: `Advertising code`,
      Displayposition: `Display position`,
      Detailed: `Detailed description/applicable page`,
      Fileformat: `File format`,
      banner: `Large banner on the front page of the mobile edition`,
      detachable: `Long, detachable banners at the bottom of each page in the mobile version`,
      homepage: `The image/movie on the home page can be closed`,
      unlimited: `Image size unlimited`,
      Image: `Image size shall not exceed 1280x720`,
      Largebanner: `Large banner for category home page (select 1 of 5) (show in walking lamp form)`,
      "Largebanner-2": `The square image/movie to the right of the category home page (choose 1 of 5)`,
      imageshould: `The width of the image should not be greater than 450px`,
      category: `Long banner at the top of the category home page (1 of 5)`,
      Cover: `Cover picture of`,
      Refer: `Refer to Facebook specifications`,
      in: `in`,
      or: `or`,
      Publish: `Publish promotion post/limited time dynamic`,
      "unlimited-2": `unlimited`,
      advertising: `New advertising format (support)`,
      Display: `Display location (including but not limited to)`,
      dimensions: `Dimension specification`,
      Right: `Right straight amplitude`,
      Audio: `Audio & Video`,
      Searchpage: `Search page`,
      squarebanner: `Right class square banner`,
      topic: `topic`,
      Topicinsidepage: `Topic inside page`,
      Insidepage: `Inside page of video and audio`,
      Longbanner: `Long banner`,
      Movie: `Movie list`
    },
    avatar: {},
    comment: {
      opinion: `Give an Opinion`,
      t1: `If you have any questions, suggestions or incorrect returns when using this website, please let us know in the comments section below. We will collect your comments.`,
      label: `Return Category`,
      labelplaceholder: `Please Select Category`,
      optionlabel11: `Member account related/unable to log in`,
      optionlabel12: `There was a problem uploading`,
      optionlabel13: `Insufficient storage space`,
      optionlabel14: `Copyright Infringement`,
      optionlabel15: `Content to be Removed (including your portrait, or illegal content report)`,
      optionlabel16: `Put Forward Suggestions`,
      optionlabel17: `Other`,
      detail: `Detailed Content`,
      detailplaceholder: `If you have any questions about your member account, please attach your account number or email address (please note that you do not need to provide a password!).`,
      name: `Contact Name`,
      email: `Contact Email`,
      response: `Do you need a customer service reply?`,
      yes: `Yes`,
      no: `No`,
      submit: `Submit`,
      opinionRules: {
        email: `Please Enter Email`,
        content: `Please Enter Details`,
        type: `Please Select a Category`,
        response: `Please choose whether you want customer service reply`
      }
    },
    commentsucces: {
      t1: "We have received your response",
      t2: "Thank you for your valuable advice.",
      t3: "Customer service will process your case within 3 working days."
    },
    contact: {
      t1: "Contact Us",
      t2: "General Query",
      t3:
        "If you encounter problems during the use of treasure hunt net need assistance or have other ideas and suggestions to put forward, welcome to contact us through the following channels, we will be dedicated to serve you.",
      t4: "Contact Number",
      t5: "Taiwan: 886-2-8,792-9897 (ext. 806)",
      t6: "Hong Kong: 852-2197-5506",
      t7: "Click Here to Contact",
      t8: "Commercial Cooperation",
      t9:
        "Welcome the cooperation of enterprises or strategic alliance partners, whether promotion activities, content, technology or other aspects of cooperation proposals, we sincerely welcome your letter, we will contact you as soon as possible.",
      t10: "Taiwan Region",
      t11: "886-2-8792-9897 (ext. 806)",
      t12: "Hong Kong Region"
    },
    cooperate: {
      t1: "Business Cooperation",
      t2:
        "Welcome the cooperation of enterprises or strategic alliance partners, whether promotion activities, content, technology or other aspects of cooperation proposals, we sincerely welcome your letter, we will contact you as soon as possible.",
      t3: "Taiwan Region",

      t4: "886-2-8792-9897 (ext. 806)",
      t5: "Hong Kong Region"
    },
    copyright: {
      t1: "Copyright protection policy of treasure hunting network",
      t2: `Scavenger respects others' Copyrights. The terms of service of Scavenger also stipulate that users shall not infringe others' Copyrights when using scavenger services. Therefore, Scavenger calls on users to respect others' Copyrights as well. If you think that any web content in the website or users using the service of the website has infringed your copyright, it is recommended that you make a report using this method, and the website will deal with it for you as soon as possible.`,
      t3: "Report measures for handling copyright infringement",
      t4: "一、Report by the right Holder:",
      t5:
        "If your copyright has been infringed by any of the contents of the website or users using the services of the website, please mail to",
      t7:
        "1. The name, contact address and contact telephone number, E-mail address or fax number of the copyright owner or his agent.",
      t8: "2. The name of the offending work or plate.",
      t9:
        "3. The URL of the page where the infringing content is located is sufficient information to enable scavenger to confirm the infringing content; And request the removal of copyright-infringing content.",
      t10:
        "4. It declares that the copyright owner is genuinely acting in good faith and believes that the infringing content is being used without legal authorization or in violation of copyright law.",
      t11:
        "5. You declare that the information contained in the notice is true and that you are the copyright owner or agent of the copyright owner.",
      t12:
        "6. The copyright owner is willing to bear legal liability if the statement on the guarantee is untrue and causes damage to scavenger or others.",
      t13: "Whistle-blowing window: Treasure Hunt E-mail",
      t14: "二、Objection of the respondent:",
      t15:
        "If you are reported by the right holder and have any objection to the claim of the right holder, please provide the information and statement and sign or seal, then send it to scavenger via email.",
      t16:
        "[Objection window: the same as the above - mentioned right holder whistleblowing window.]",
      t17: "Principles of handling scavenger net:",
      t18:
        "1. Upon receipt of the notice from the right holder, Scavenger will remove as soon as possible the contents of the Web pages alleged by the right holder to be infringing on copyright, and transfer the contents to the right holder according to the contact information agreed between Scavenger and the user or the contact information retained by the user. Scavenger may provide the user with the processing information, including the name, E-mail or telephone number of the right holder, so that the user can directly communicate with the right holder to resolve the dispute. If the copyright infringement notice is incomplete, Scavenger will notify the right holder to correct the relevant information.",
      t19:
        "2. Please note that if a user's web content is claimed by the right holder to be involved in the infringement of its copyright, once the content has been deleted by Scavenger, Scavenger can no longer reply. If a user is involved in infringement three times, Treasure hunting network will terminate all or part of the service of the user.",
      t20:
        "3. However, if a netizen has objections to the infringement claimed by the right holder, the netizen may check the notice document and request the Treasure hunting network to transfer the notice document to the right holder to express objections; If the user's notice is incomplete, Treasure Hunt will notify the user to correct the relevant information. Upon receipt of the notice document mentioned in the preceding paragraph, Scavenger will immediately forward the notice document to the right holder. If the right holder fails to submit proof that a lawsuit has been filed against the netizen within 10 working days from the day after receiving the notice document, the netizen may upload the content again by himself.",
      t21:
        "4. If the notice of the above-mentioned right holders or netizens is incomplete, the Treasure hunting website may correct the relevant information by E-mail or fax notice provided by them.",
      t22:
        "5. The right holder or netizens must complete the rectification within five working days from the day after receiving the rectification notice of the Treasure Search website. If the rectification is not completed or not completely corrected by the deadline, the notice is not submitted according to the provisions of the Copyright Law.",
      t23:
        "6. According to the terms and conditions of the Privacy Policy of Scavenger, except with the consent of the user or for the purpose of providing the service, Scavenger may only provide the user's identifying information to third parties as required by law or government authorities. Therefore, if you report in accordance with these Measures, Scavenger will only remove the infringing content at your request, and will not provide you with identifying information about the user. If you wish to obtain the user data, you should inform the District Court Prosecutor's Office or the Criminal Police station, and Treasure Hunt will cooperate with the former unit to provide the user data after the letter."
    },
    deleteComment: {},
    Editor: {},
    eventsucces: {
      t1: "Activity Submitted Successfully",
      t2:
        "Thank you for your information, we will publish the information as soon as possible",
      t3: "Back to Activity Homepage"
    },
    Footer: {
      t1:
        "Some of the information on this website is provided by users, if it infringes your copyright, please",
      t2: "Contact Us",
      t3: `2021 Treasure Hunt SOONNET.org. All Rights
Reserved.`
    },
    ImgCropper: {
      footer: "Cancel",
      primary: "Verify"
    },
    initFoot: {},
    maintain: {},
    messageLink: {},
    Page: {},
    page2: {},
    pagination: {},
    privacy: {
      t1: "Privacy Policy",
      t2: "Contents of the Privacy Policy",
      t3:
        "Scavenger takes your privacy very seriously. Please read more about the privacy policy below.",
      t4: "How Scavenger uses your personal data",
      t5:
        " This policy covers, among other things, how Scavenger handles personal information collected or received (including information related to your past use of Scavenger products and services). Personal data is information that identifies you and is not publicly available, such as your name, address, email address or telephone number.",
      t6: "This privacy policy applies only to Scavenger",
      t7:
        "This policy does not apply to companies not owned or controlled by Scavenger, nor to persons not employed or managed by Scavenger.",
      t8: "Data Collection and use",
      t9: "Pandect",
      t10:
        "Scavenger collects personal information from you when you register for a Scavenger account, use Scavenger products or services, visit Scavenger pages or the pages of certain partners, and participate in promotional events or prize games. Scavenger may also combine information about you provided by business partners or other businesses with your personal data held by Scavenger.",
      t11:
        "When you register with Scavenger, we ask for your name, email address, date of birth, gender and postal code. When you use certain services, we may also ask you for your address, identity card number and information about your property. After you register for a Scavenger account and log in to our services, we will be able to identify you. You are free to choose whether or not to provide personal data to us, but if certain data fields are required, you will not be able to use the relevant Scavenger products and services if you do not provide such data.",
      t12:
        "Scavenger collects information about your transactions with us or our business partners, including information about your use of the services we provide.",
      t13:
        "Scavenger also automatically receives and records data on your computer and browser, including IP addresses, data in Scavenger cookies, software and hardware properties, and a history of web pages you visit.",
      t14:
        "During your use of our products and services, our data may be used worldwide for the following purposes: to customize advertising and the content of the pages you see, to meet your requirements for products and services, to improve our services, to contact you, to conduct research, and to provide internal and external customers with market analysis or business reports that do not contain personal data.",
      t15:
        "The specific purposes for which we collect, process and use personal data are as follows: marketing business, consumer, customer management and services, information and communication services, online shopping and other e-commerce services, advertising and business conduct management business and other contractual, contractual or legal relationship management business or business.",
      t16: "Data collection and use",
      t17: "Data sharing and disclosure",
      t18:
        "We will not provide or share your personal data with any other person or non-affiliated company except to provide you with the products or services you have requested, to obtain your authorization, or to:",
      t19:
        "(i) We provide this information to trusted partners who have signed non-disclosure agreements to perform business on behalf of or with us. These companies may use your personal data to assist Scavenger in communicating with you regarding products and services offered by us and our marketing partners. But the companies have no independent right to share the data.",
      t20:
        "(ii) We respond to subpoenas, court orders or legal proceedings, obtain or exercise legal rights, or defend against claims in litigation.",
      t21:
        "(iii) When we believe it is necessary to share your personal data in order to investigate and prevent illegal activities, suspected fraud, situations of potential threat to personal safety, violations of the Terms of Service, or to respond to the above situations, or as otherwise required by law.",
      t22:
        "(iv) If all or part of our business is acquired or merged with another company, we will transfer your personal data to that company. If this happens, Scavenger will notify you before your personal data is transferred and a different privacy policy applies.",
      t23:
        "(v) Scavenger will show you targeted marketing ads based on your personal data. Advertisers (including AD delivery companies) may assume that those who view, click on, or interact with targeted marketing ads meet targeted marketing criteria, such as women ages 18 to 24 in a specific geographic area.",
      t24:
        "(vi) When you view or interact with targeted marketing ads, Scavenger will not provide advertisers with any personal information about you. However, by viewing or interacting with an AD, you agree that the advertiser may assume that you meet the precision marketing standards used in display ads.",
      t25:
        "(vii) Scavenger advertisers include financial service providers (such as banks, insurance agents, securities brokers, and mortgage lenders) and non-financial companies (such as stores, airlines, and software companies).",
      t26:
        "(viii) Scavenger works with suppliers, partners, advertisers and other service providers in a wide range of industries. To find out more about the product or service provider you need.",
      t27: "Scavenger will set and access a Scavenger cookie on your computer.",
      t28:
        "Scavenger allows other companies that advertise on certain Scavenger pages to set and access cookies on your computer. Other companies will use their cookies in accordance with their own privacy policies and not in accordance with this Policy. Advertisers or other companies cannot access the cookies of Scavenger.",
      t29:
        "Your ability to query, modify and delete your personal account information and preferences",
      t30: "pandect",
      t31:
        "You can query, view, copy and modify your personal Scavenger account information, including marketing preferences, at any time.",
      t32:
        "From time to time, Scavenger may add new categories of marketing messages to the Marketing Preferences page. Users browsing this page can opt out of receiving new categories of marketing messages or unsubscribe from them as instructed in the received messages.",
      t33:
        "We reserve the right to send you specific messages (such as service announcements, administrative messages) related to the Scavenger Service, which are considered part of your Scavenger account and you cannot opt out of receiving them.",
      t34:
        "If you would like to delete your Treasure Hunt account, please contact us.",
      t35: "Confidentiality and security",
      t36:
        "We limit access to your personal data to employees who we reasonably believe need it to provide you with products or services or to perform their jobs.",
      t37:
        "We have put in place physical, electronic and procedural safeguards that meet regulatory requirements to protect the security of your personal data. Whether consent is given or not.",
      t38: "Revised Privacy policy",
      t39:
        "Scavenger may revise this policy from time to time. When there is a material change in the processing of personal data, we will send a notification to the primary email address specified in your Scavenger account or post a notice on our website.",
      t40: "Questions and suggestions",
      t41:
        "If you have any questions or suggestions, please contact us by email.",
      t42: "Effective date: September 19, 2013"
    },
    profileNavItem: {},
    Report: {
      placeholder: "The title contains a maximum of 28 Chinese characters",
      option: "Please Select",
      confirm: "Confirm Submission"
    },
    /**太多了 先不弄 */
    service: {},
    SocialButton: {},
    sortLink: {},
    uploadImg: {},
    userComments: {
      message: "Recover"
    },
    userCommentsItem: {
      placeholder: "Enter your message",
      submitComment: "Send"
    }
  },
  Customer: {
    customerFavorite: {
      customerPublish: "Published Content",
      customerFavorite: "Bookmarks",
      customerPrivateMessage: "Private Message",
      customerInfo: "Settings",
      album: "Album",
      picture: "Photo",
      movie: "Video",
      activity: "Activity",
      topic: "Articles",
      feed: "Dynamic",
      blog: "Blog",
      search: "Search",
      loading: "Loading",
      empty: "No Data",
      uncollect: "Uncollect",
      share: "Share",
      Nophoto: "No Photo",
      uploader: "Uploader",
      Uploaddate: "Upload Date",
      newslessness: "Newslessness",
      anechoic: "Anechoic",
      film: "Dynamic Video",
      photo: "Dynamic Photo",
      text: "Dynamic Message",
      date: "Date",
      Controls: "Controls",
      view: "View",
      Pastactivity: "Past Activity",
      Activityname: "Activity Name",
      type: "Type",
      Locations: "Locations",
      Registrationstatus: "Registration Status",
      Futureactivity: "Future Activity",
      day: "Day"
    },
    customerInfo: {
      customerPublish: "Published Content",
      customerFavorite: "Bookmarks",
      customerPrivateMessage: "Private Message",
      customerInfo: "Settings",
      setting: "Personal Data Setting",
      Changepassword: "Change Password",
      profilepicture: "Personal Profile Picture",
      Membername: "Member Name",
      UsersName: "The name you appear on the community",
      MyVideoName: "Short Video Name",
      customerMyVideoName: "The name you display on the short video movie",
      selfintroduction: "Self-Introduction",
      sgL_Myself: "A brief introduction of yourself",
      Sex: "Sex",
      Male: "Male",
      Female: "Female",
      BirthF: "Date of Birth",
      SelfNetworkDiskF: "Album Space",
      Havebeenused: "Have Been Used",
      gross: "Gross Amount",
      information: "Receive Information",
      Soonnet: "I'd like to receive updates from Soonnet",
      no: "No",
      store: "Store",
      Currentpassword: "Current Password",
      newpw: "New Password",
      repeatpw: "Reenter Password",
      changepw: "Change Password",
      reciver: "Received Message",
      sent: "Sent Message",
      search: "Search",
      msg: "Message Content",
      user: "User",
      date: "Date",
      Controls: "Controls",
      check: "View",
      del: "Delete",
      PwmodelRule: {
        pw: `Please enter your current password`,
        newpw: `Please enter a new password`,
        repeatpw: `Please re-enter your password`
      },
      customerModelrule: {
        sgL_UsersName: `Please enter your username`,
        sgL_MyVideoName: `Please enter the short video name`
      }
    },
    customerLogin: {
      Login: "Login",
      user: "User Name/Email Address",
      password: "Password",
      loggedin: "Stay Logged In",
      Forgopassword: "Forgot Your Password?",
      registerEmail: "Not Yet a Member?",
      register: "Click Here to Register",
      or: "or",
      Facebook: "Sign in with your Facebook account",
      loginRules: {
        name: `Please fill in email or user name`,
        password: `Please fill in the password`
      }
    },
    customerMessage: {
      customerPublish: "Published Content",
      customerFavorite: "Bookmarks",
      customerPrivateMessage: "Private Message",
      customerInfo: "Settings",
      reciver: "Received Message",
      sent: "Sent Message",
      search: "Search",
      msg: "Message Content",
      user: "User",
      date: "Date",
      Controls: "Controls",
      check: "View",
      del: "Delete"
    },
    customerPrivateMessage: {
      msg: "Private Message",
      replay: "Reply",
      reject: "Delete",
      agree: "Friend",
      sendMsg: "Type in conversation",
      dialogue: "Conversation"
    },
    customerPublish: {
      search: "Search",
      customerPublish: "Published Content",
      Homepage: "User Homepage",
      customerFavorite: "Bookmarks",
      customerPrivateMessage: "Private Message",
      customerInfo: "Settings",
      Photoalbum: "Photo Album",
      videofeed: "Dynamic Video",
      motionpicture: "Dynamic Photo",
      blog: "Blog",
      message: "My Message",
      loading: "Loading",
      Noalbum: "No Album",
      processed: "Processed",
      piece: "Piece",
      bookmark: "Collect",
      share: "Share",
      del: "Delete",
      Noaudio: "No audio or video activity",
      link: "Copy Link",
      publicity: "Publicity",
      Notpublic: "Hidden",
      Nophotograph: "No Motion Photograph",
      blogprofile: "Set Up a Blog Profile",
      Subscriberdata: "Subscriber Data",
      Postviews: "Post Views",
      title: "Title",
      Totalpageviews: "Views Count",
      Subscribe_browse: "Subscribers View",
      Addsubscription: "New Subscribers",
      praise: "Likes",
      releasedate: "Published date",
      subscriber: "Subscriber",
      Hide_post: "Hide Post",
      Display_post: "Display Post",
      Edit_post: "Edit",
      del_post: "Delete",
      suggestedsize: "Article Cover (Recommended Size",
      uploadpictures: "Upload Cover",
      Blog_post_title: "Post Title",
      Article_content: "Content",
      Reprint_source: "Source of Reprint",
      Keywords: `Keywords (separated by ",", no space required)`,
      Chartered:
        "e.g. race coverage, road running, Standard Chartered Marathon",
      Open_state: "Open State",
      reveal: "Display",
      Hidden: "Hidden",
      Cancel: "Cancel",
      save: "Save",
      Blog_flag: "Blog Flag",
      Blog_name: "Blog Name",
      appears: "The name that appears in the blog",
      Blog_introduction: "Blog Introduction",
      Blog_intro: "Blog Brief Introduction",
      Storage_setting: "Storage Setting",
      Received_message: "Received Message",
      Sent_message: "Sent Message",
      Message_content: "Message Content",
      user: "User",
      date: "Date",
      Controls: "Controls",
      check: "View",
      Subscribed_subscriber: "Subscribed Subscriber"
    },
    customerPublishLook: {
      msg: "Private Message",
      agree: "Add Friends",
      Photo_album: "Album",
      film: "Video",
      group: "Group",
      search: "Search",
      loading: "Loading",
      No_album: "No Album",
      No_film: "No Film",
      No_data: "No Data",
      Apply: "Apply Group",
      placeholder: "What do you want to say to him",
      sendMessage: "Send"
    },
    customerRegist: {
      register: "Sign In",
      mailbox: "Mailbox",
      customerName: "User Name (Community display name)",
      customerPwd: "Password",
      customerRePwd: "Reenter Password",
      sex: "Sex",
      Male: "Male",
      Female: "Female",
      customerBirth: "Date of Birth",
      checkDate: "Select Date",
      customerArea: "Local Area",
      t1: "Taiwan - Taipei City",
      t2: "Taiwan - New Taipei City",
      t3: "Taiwan - Taoyuan City",
      t4: "Taiwan - Taichung City",
      t5: "Taiwan - Tainan City",
      t6: "Taiwan - Kaohsiung City",
      t7: "Taiwan - Jilong City",
      t8: "Taiwan - Hsinchu City",
      t9: "Taiwan - Chiayi City",
      t10: "Taiwan - Hsinchu county",
      t11: "Taiwan - Miaoli county",
      t12: "Taiwan - Changhua county",
      t13: "Taiwan - Nantou county",
      t14: "Taiwan - Yunlin county",
      t15: "Taiwan - Chiayi county",
      t16: "Taiwan - Pingtung county",
      t17: "Taiwan - Yilan county",
      t18: "Taiwan - Hualien county",
      t19: "Taiwan - Taitung county",
      t20: "Taiwan - Penghu county",
      t21: "Hong Kong Special Administrative Region",
      t22: "Macao Special Administrative Region",
      t23: "Chinese Mainland",
      t24: "Overseas Region",
      Soonnet: "I'd like to receive updates from Soonnet",
      agreed: "I have read and agreed",
      service: "Terms of Service",
      policy: "Privacy Policy",
      clause: "Copyright Clause",
      ors: "And",
      registerRules: {
        customerEmail: {
          error1: `Please enter your email address`,
          error2: `Please enter the correct email address`
        },
        customerName: `Please enter the community name`,
        customerPwd: `Please enter a password of more than 6 characters`,
        customerRePwd: {
          error1: `Please Enter Password`,
          error2: `Two Different Password Entries!`
        }
      }
    },
    forgotPassword: {
      Forgot_password: "Forgot Password",
      email: "Enter Your Email,",
      link: "You will be sent an email with a link to reset your password.",
      mailbox:
        "(If you can't receive mail smoothly, please check your spam mailbox)",
      Electronic_mail: "Electronic Mail",
      please: "If you need assistance, please",
      contact_us: "Contact Us",
      registerEmailRules: {
        error1: "Please enter your email address",
        error2: "Please enter the correct email address"
      },
      btntext: {
        title1: "Reset Password",
        title2: `Send again after seconds`
      }
    },
    registerEmail: {
      register: "Signin",
      submit: "Submit"
    },
    registerSuccess: {
      register: "Registered Successfully",
      title:
        "You have successfully registered as a member of Scavenger, please login again.",
      toLogin: "Return to Login Page"
    },
    resetPassword: {
      reset_password: "Reset Password",
      resetpassword: "Please set your new password",
      newwpd: "New Password",
      repeatPassword: "Re-enter the new password",
      error1: "Please Enter Password",
      error2: "The two password entries are inconsistent"
    },
    resetPwSuccess: {
      msg: "Successfully reset the password",
      msg1: "Your password has been reset, please log in again.",
      msg2: "Return to login page"
    }
  },
  loginFun: {
    certification: {
      authentication: "Authentication",
      userName: "Name",
      videoName:
        "The user name displayed is limited to a maximum of six Chinese characters",
      area: "Local Area",
      area_placeholder: "Please Select a Region",
      verificationCode: "Verification Code",
      isCheck: "I have read and agreed",
      certificationTerms: "Real-name authentication clause",
      or: "And",
      copyright: "Copyright Clause",
      promise:
        "When you press the button, you accept and promise to abide by the terms",
      closealarmModal: "You have completed certification",
      verify: "Verify"
    },
    certificationFlow: {
      description: "Real name authentication process and description",
      authenticate: "Why should I authenticate my phone?",
      msg: `In order to ensure that the users of Scavenger network can obtain a good use environment, avoid excessive account applications and illegal content published by interested people, users should provide real information when applying for an account and carry out the member "account real name system" through mobile phone authentication, to ensure that users are the owners of the rights and interests of the account, and users must be responsible for the content published.`,
      protection: "Real name authentication protection and terms",
      certificationTerms: "Click here to view",
      certification: "Mobile phone certification process and description",
      msg2:
        "After the registered user has logged in, the current account email will be displayed to confirm whether the account to be authenticated is correct. If there is no error, you can directly fill in the information below.",
      msg3:
        "The newly registered user will enter the authentication page after completing the registration",
      msg4:
        "Fill in your name information. (This information will not be displayed anywhere on the website for authentication purposes only)",
      msg5:
        "The name entered will be used as a personal title for display in the video or in the future; Limit up to 6 characters in Chinese /12 characters in English and numerals",
      msg6: `Select now certified phone number "Region"`,
      msg7: `Fill in the now certified "Phone number"`,
      msg8: `Enter the "authentication code" received by the mobile phone authentication number`,
      msg9: `Click on "Real name authentication Terms" and "Copyright Terms" to read the relevant terms in detail, and agree to check this box to continue authentication`,
      msg10: `It is the same as the "real name authentication terms" in the seventh point, but it is provided for direct reading. If the option in the seventh step is checked, the authentication can continue`,
      msg11: `Click "Certification" to complete the certification process and record`,
      comparison: `Functional Comparison`,
      contrast: `Functional Comparison`,
      Uncertified_member: `Uncertified Member`,
      Mobile_certified_member: `Mobile Certified Member`,
      upload_photos: `Activity - Upload Photos`,
      Photo_likes: `Activity - Photo Likes`,
      Photo_sharing: `Activities - Photo Sharing`,
      Photo_collection: `Activities - Photo Collection`,
      bib_search: `Road Photo - Bib Search`,
      face_Search: `Road Photos - Photo Face Search`,
      Community_Message: `Community - Message`,
      Community_Upload_photos: `Community - Upload Photos`,
      Upload_short_videos: `Community - Upload Short Videos`
    },
    certificationTerms: {
      t1: `Real-name authentication clause`,
      t2: `Why should I authenticate my phone?`,
      t3: `In order to ensure that the users of Scavenger network can obtain a good use environment, avoid excessive account applications and illegal content published by interested people, users should provide real information when applying for an account and carry out the member "account real name system" through mobile phone authentication, to ensure that users are the owners of the rights and interests of the account, and users must be responsible for the content published.`,
      t4: `Certification process and description`,
      t5: `Click here to view`,
      t6: `Will my information be leaked?`,
      t7: `The personal information you provide is protected by the Personal Information Law and the privacy protection policy of Scavenger, and will only be used for member identity authentication, Scavenger service provision and relevant notices, etc., and will not be disclosed to third parties at will. Please help this website to provide better service and peace of mind experience.`,
      t8: `The name, contact address and contact telephone number, E-mail or fax number of the copyright owner or the copyright owner's agent.`,
      t9: `The name of the offending work or plate.`,
      t10: `The website address (URL) of the page where the infringing content is located and other relevant information sufficient to enable Scavenger to confirm that the infringing content is involved; And request the removal of copyright-infringing content.`,
      t11: `A statement that the copyright owner is acting in good faith and believes that the use of the infringing content is unauthorized or in violation of copyright law.`,
      t12: `You declare that the information contained in this notice is true and that you are the copyright owner or the copyright owner's agent.`,
      t13: `The copyright owner is willing to bear legal responsibility if the statement on the guarantee is untrue and causes damage to the treasure hunting network or others.`,
      t14: `Relevant regulations`,
      t15: `In order to provide a better user experience, if you agree and need to use all the details of the service, you must go through the system certification developed by the treasure, otherwise the treasure need not provide the complete service content.`,
      t16: `You must provide complete, detailed and true personal information at the time of registration. If the loss of Scavenger network is caused by your false Posting, Scavenger Network may claim damages and punitive damages and have the right to stop the use of member accounts, and Scavenger network does not have to bear any liability for damages. At the same time, you shall assume the relevant civil criminal liability. Treasure hunt will be transferred to the judicial unit.`,
      t17: `Scavenger provides "AOTP verification service" as a method of member verification. "AOTP Verification Service" is a new generation of telecom verification method that verifies the SIM card mobile phone number and verification code of the sender after sending a short message to the specified telecom code, which is used to improve the security of the existing SMS OTP verification to ensure your user rights and interests.`,
      t18: `When you use the Service, you should guarantee that you are the legitimate user of the mobile phone number, and after using the Service, you will be responsible for all actions of the account that uses the Service.`,
      t19: `Real login obligations:`,
      t20: `If Party B agrees and needs to use all details of Party A's services, it must be certified by the system formulated by Party A, otherwise Party A does not need to provide the complete service content.`,
      t21: `Party B shall provide complete, detailed and true personal information at the time of registration, and Party B shall update online or apply for changes through membership services at any time if the registered information is changed afterwards. If Party B intentionally posts false personal information, it shall constitute the cause of breach of contract. If Party A finds it and notifies Party B to correct it, Party B shall correct it within _7 days. If Party B still fails to correct it, Party A may suspend the right to use its member account for 7 days and shall not be liable for any damages. If Party A loses money due to Party B's false publication, Party A shall claim damages and punitive damages, and Party B shall bear the relevant civil criminal liability (including but not limited to the criminal law, falsification of documents, fraud, obstruction of electromagnetic records and other relevant criminal chapter).`,
      t22: `If the personal information provided by Party B is untrue, or the original registered information is no longer true and has not been updated, or there is any other misleading suspicion, Party A reserves the right to suspend Party B from using the Services at any time before Party B provides the true information or updates the information.`,
      t23: `User obligations:`,
      t24: `In the process of using the Service, you must provide your mobile phone number and other personal data and information required for the registration and opening of the Service, and you should guarantee that the information you provide is true, correct, current and complete. If there is any change in the information provided by you, you should immediately update the Company on your own initiative. If the information and personal information provided by you are not true, correct, not updated or incomplete, you shall bear the relevant losses and the damage or loss suffered by the Company as a result.`,
      t25: `You should ensure the security of your mobile phone and its information system to prevent unauthorized access, access, tampering with, or destruction of records or data therein, and install any software, firmware or other code necessary to use the Service. If your mobile phone is used for any reason, any damage or loss caused to your use of the Service by the aforementioned illegal intrusion, etc., you shall be solely responsible for it. The Company takes relevant measures in accordance with the law to protect the security of your personal data, but does not guarantee the accuracy of the information you fill in the network transmission, if you find errors, please notify the company immediately, and check the relevant information to request correction, otherwise the company will use the information content obtained.`,
      t26: `The user shall use in accordance with the instructions on this service page, except for special conditions and regulations, will be able to enjoy the full membership rights and benefits of cooperative stores and preferential services.`,
      t27: `(hereinafter referred to as the "Site"), in order to provide a better user experience, in accordance with the site AOTP verification`,
      t28: `Terms of Service Use (hereinafter referred to as the "Terms"), providing AOTP verification services (hereinafter referred to as the "Service")`,
      t29: `As a way of account verification, please be sure to read these terms in detail before using the Service to protect your rights and interests. When you start to use the Service, you are deemed to have read, understood and agreed to abide by these Terms.`,
      t30: `一、Service content and basic specifications`,
      t31: `This service is a new generation of telecom verification method that verifies the SIM card phone number and verification code of the sender after sending the SMS to the specified telecom code. It is used to improve the security of the existing SMS OTP verification to ensure your user rights and interests. Currently, only Chunghua Telecom, Far East Telecom, Taiwan Mobile, Asia Pacific Telecom and Taiwan Star Telecom monthly rent users are accepted.`,
      t32: `After using this service, you will be charged a $3 premium message fee on your next telecom bill. This fee is the verification service fee of the five major telecom operators, SMS and verification service operators, the site does not charge any fees, and does not intervene in the collection and payment of certification fees.`,
      t33: `二、Service usage Responsibilities and obligations`,
      t34: `When you use the Service, you should guarantee that you are the legitimate user of the mobile phone number, and after using the Service, you will be responsible for all actions of the account that uses the Service.`,
      t35: `When you use the Service, in addition to complying with the laws of the Republic of China, international Internet regulations and practices, the site user terms and conditions and these Terms and conditions, if you violate the provisions, the site suffered damage or expenses (including but not limited to legal costs and attorney fees), shall be liable for damages. If there are criminal offenders involved, this site may be transferred to the competent authorities or judicial units to deal with.`,
      t36: `The mobile phone number for which the SMS verification code is transmitted by the Service shall be properly kept by the applicant. If the obligation of keeping the mobile phone number is not fulfilled, the applicant shall be solely responsible for the damage caused by the mobile phone number for which the SMS verification code is transmitted. If the use of this mobile phone number for verification is not authorized to use, it shall bear legal responsibility.`,
      t37: `三、Cessation or termination of the service`,
      t38: `You agree that administrators of the Site have the right, in their sole discretion, to terminate the Service or any portion of the Service at any time, including but not limited to canceling account authentication of the Service and prohibiting mobile phone numbers used for the Service.`,
      t39: `If you violate these Terms, User Terms, relevant laws or other improper use of this site, this site may restrict or terminate your right to use this site without notice, and you shall not be liable for compensation or compensation.`,
      t40: `四、disclaimer`,
      t41: `This site is not responsible for any guarantee of the Service, and does not guarantee the stability, accuracy, safety and uninterrupted service. If the user's authentication fails due to system interruptions or obstacles, the manufacturer's fees will not be refundable. However, this site is willing to properly understand your complaint and respond appropriately to the manufacturers who provide this service.`,
      t42: `The site reserves the right to amend these terms at any time, but after modification or change, without separate notice, you shall not claim any compensation or compensation.`
    },
    certificationTermsIframe: {
      t1: `Real-name authentication clause`,
      t2: `Why should I authenticate my phone?`,
      t3: `In order to ensure that the users of Scavenger network can obtain a good use environment, avoid excessive account applications and illegal content published by interested people, users should provide real information when applying for an account and carry out the member "account real name system" through mobile phone authentication, to ensure that users are the owners of the rights and interests of the account, and users must be responsible for the content published.`,
      t4: `Will my information be leaked?`,
      t5: `The personal information you provide is protected by the Personal Information Law and the privacy protection policy of Scavenger, and will only be used for member identity authentication, Scavenger service provision and relevant notices, etc., and will not be disclosed to third parties at will. Please help this website to provide better service and peace of mind experience.`,
      t6: `The name, contact address and contact telephone number, E-mail or fax number of the copyright owner or the copyright owner's agent.`,
      t7: `The name of the work or platemaking subject to infringement. User's obligations:`,
      t8: `The website address (URL) of the page where the infringing content is located and other relevant information sufficient to enable Scavenger to confirm that the infringing content is involved; And request the removal of copyright-infringing content.`,
      t9: `A statement that the copyright owner is acting in good faith and believes that the use of the infringing content is unauthorized or in violation of copyright law.`,
      t10: `You declare that the information contained in this notice is true and that you are the copyright owner or the copyright owner's agent.`,
      t11: `The copyright owner is willing to bear legal responsibility if the statement on the guarantee is untrue and causes damage to the treasure hunting network or others.`,
      t12: `Relevant regulations`,
      t13: `In order to provide a better user experience, if you agree and need to use all the details of the service, you must go through the system certification developed by the treasure, otherwise the treasure need not provide the complete service content.`,
      t14: `You must provide complete, detailed and true personal information at the time of registration. If the loss of Scavenger network is caused by your false Posting, Scavenger Network may claim damages and punitive damages and have the right to stop the use of member accounts, and Scavenger network does not have to bear any liability for damages. At the same time, you shall assume the relevant civil criminal liability. Treasure hunt will be transferred to the judicial unit.`,
      t15: `Scavenger provides "AOTP verification service" as a method of member verification. "AOTP Verification Service" is a new generation of telecom verification method that verifies the SIM card mobile phone number and verification code of the sender after sending a short message to the specified telecom code, which is used to improve the security of the existing SMS OTP verification to ensure your user rights and interests.`,
      t16: `When you use the Service, you should guarantee that you are the legitimate user of the mobile phone number, and after using the Service, you will be responsible for all actions of the account that uses the Service.`,
      t17: `Real login obligations:`,
      t18: `If Party B agrees and needs to use all details of Party A's services, it must be certified by the system formulated by Party A, otherwise Party A does not need to provide the complete service content.`,
      t19: `Party B shall provide complete, detailed and true personal information at the time of registration, and Party B shall update online or apply for changes through membership services at any time if the registered information is changed afterwards. If Party B intentionally posts false personal information, it shall constitute the cause of breach of contract. If Party A finds it and notifies Party B to correct it, Party B shall correct it within _7 days. If Party B still fails to correct it, Party A may suspend the right to use its member account for 7 days and shall not be liable for any damages. If Party A loses money due to Party B's false publication, Party A shall claim damages and punitive damages, and Party B shall bear the relevant civil criminal liability (including but not limited to the criminal law, falsification of documents, fraud, obstruction of electromagnetic records and other relevant criminal chapter).`,
      t20: `If the personal information provided by Party B is untrue, or the original registered information is no longer true and has not been updated, or there is any other misleading suspicion, Party A reserves the right to suspend Party B from using the Services at any time before Party B provides the true information or updates the information.`,
      t21: `User obligations:`,
      t22: `In the process of using the Service, you must provide your mobile phone number and other personal data and information required for the registration and opening of the Service, and you should guarantee that the information you provide is true, correct, current and complete. If there is any change in the information provided by you, you should immediately update the Company on your own initiative. If the information and personal information provided by you are not true, correct, not updated or incomplete, you shall bear the relevant losses and the damage or loss suffered by the Company as a result.`,
      t23: `You should ensure the security of your mobile phone and its information system to prevent unauthorized access, access, tampering with, or destruction of records or data therein, and install any software, firmware or other code necessary to use the Service. If your mobile phone is used for any reason, any damage or loss caused to your use of the Service by the aforementioned illegal intrusion, etc., you shall be solely responsible for it. The Company takes relevant measures in accordance with the law to protect the security of your personal data, but does not guarantee the accuracy of the information you fill in the network transmission, if you find errors, please notify the company immediately, and check the relevant information to request correction, otherwise the company will use the information content obtained.`,
      t24: `The user shall use in accordance with the instructions on this service page, except for special conditions and regulations, will be able to enjoy the full membership rights and benefits of cooperative stores and preferential services.`,
      t25: `(hereinafter referred to as the "Site"), in order to provide a better user experience, in accordance with the site AOTP verification`,
      t26: `Terms of Service Use (hereinafter referred to as the "Terms"), providing AOTP verification services (hereinafter referred to as the "Service")`,
      t27: `As a way of account verification, please be sure to read these terms in detail before using the Service to protect your rights and interests. When you start to use the Service, you are deemed to have read, understood and agreed to abide by these Terms.`,
      t28: `一、Service content and basic specifications`,
      t29: `This service is a new generation of telecom verification method that verifies the SIM card phone number and verification code of the sender after sending the SMS to the specified telecom code. It is used to improve the security of the existing SMS OTP verification to ensure your user rights and interests. Currently, only Chunghua Telecom, Far East Telecom, Taiwan Mobile, Asia Pacific Telecom and Taiwan Star Telecom monthly rent users are accepted.`,
      t30: `After using this service, you will be charged a $3 premium message fee on your next telecom bill. This fee is the verification service fee of the five major telecom operators, SMS and verification service operators, the site does not charge any fees, and does not intervene in the collection and payment of certification fees.`,
      t31: `二、Service usage Responsibilities and obligations`,
      t32: `When you use the Service, you should guarantee that you are the legitimate user of the mobile phone number, and after using the Service, you will be responsible for all actions of the account that uses the Service.`,
      t33: `When you use the Service, in addition to complying with the laws of the Republic of China, international Internet regulations and practices, the site user terms and conditions and these Terms and conditions, if you violate the provisions, the site suffered damage or expenses (including but not limited to legal costs and attorney fees), shall be liable for damages. If there are criminal offenders involved, this site may be transferred to the competent authorities or judicial units to deal with.`,
      t34: `The mobile phone number for which the SMS verification code is transmitted by the Service shall be properly kept by the applicant. If the obligation of keeping the mobile phone number is not fulfilled, the applicant shall be solely responsible for the damage caused by the mobile phone number for which the SMS verification code is transmitted. If the use of this mobile phone number for verification is not authorized to use, it shall bear legal responsibility.`,
      t35: `三、Cessation or termination of the service`,
      t36: `You agree that administrators of the Site have the right, in their sole discretion, to terminate the Service or any portion of the Service at any time, including but not limited to canceling account authentication of the Service and prohibiting mobile phone numbers used for the Service.`,
      t37: `If you violate these Terms, User Terms, relevant laws or other improper use of this site, this site may restrict or terminate your right to use this site without notice, and you shall not be liable for compensation or compensation.`,
      t38: `四、disclaimer`,
      t39: `This site is not responsible for any guarantee of the Service, and does not guarantee the stability, accuracy, safety and uninterrupted service. If the user's authentication fails due to system interruptions or obstacles, the manufacturer's fees will not be refundable. However, this site is willing to properly understand your complaint and respond appropriately to the manufacturers who provide this service.`,
      t40: `The site reserves the right to amend these terms at any time, but after modification or change, without separate notice, you shall not claim any compensation or compensation.`
    },
    login: {
      administrator: "Treasure hunt network management background",
      username: "Username",
      password: "Please Enter Password",
      loginmodel: "Login",
      or: "or",
      facebook: "Sign in with your Facebook Account",
      loginrules: {
        username: `Please Enter your Username`,
        password: `Please Enter Password`
      }
    }
  },
  Social: {
    cloubDetail: {
      lookCount: "Views"
    },
    cloubTool: {},
    CreateFeed: {
      Newpost: "Add new dynamic",
      ShareContent: "What do you want to share today?",
      uploadUrl: "Add New Photos",
      Newfilm: "Adding New Videos",
      save: "Publish"
    },
    DataView: {
      bookmark: "Bookmark",
      flag: "Report",
      delbolg: "Delete",
      thumbs: "Like",
      comment: "Reply",
      share: "Share",
      placeholder: "Enter your message..."
    },
    DisplayVideo: {
      clone: "Copy Links",
      bookmark: "Bookmark",
      share: "Share",
      flag: "Report",
      recover: "Reply",
      keyWord: "Keyword",
      placeholder: "Enter your message...",
      placeholder2: "Enter your message...",
      hit: "The Most Hit Movie Anchor"
    },
    Feed: {
      date: "Click here to select the date",
      loading: "Loading...",
      loading2: "No More Data"
    },
    FeedCard: {},
    FeedCloud: {
      sorting: " Sort:",
      newvideo: " Latest Video",
      hitvideo: " Top Video",
      uploadvideo: " Upload Video",
      clone: "Copy Links",
      bookmark: "Bookmark",
      share: "Share",
      flag: "Report"
    },
    FeedHome: {},
    FeedPerson: {},
    Heart: {},
    moreMenu: {},
    MyDynamic: {
      msg: "Why haven't you tried publishing stories yet?"
    },
    MyDynamicPic: {
      photo: `Photo`,
      film: `Film`,
      Search_dynamics: `Search Dynamics`,
      clone: `Copy Links`,
      open: `Public`,
      noOpen: `Not Public`,
      del: `Delete`
    },
    ReportMask: {
      msg: `This video has been reported as "inappropriate content" pending confirmation. The movie will be hidden or deleted after the administrator confirms`
    },
    singleVideo: {},
    TempPage: {},
    UploadStep: {},
    UserFeedInfo: {
      login: "Not logged in, click here to log in",
      home: "Dynamic Feed",
      video: "Dynamic Videos",
      group: "Social Group",
      user: "Friends List",
      comments: "Private Message"
    },
    video: {},
    VideoUpload: {
      msg: "Drag the file here, or",
      Clickupload: "Click Upload",
      Selected: "Selected File:",
      Only: "Only mp4/mov/mpg/3gp/flv file formats are supported",
      uploads: "Only videos with a duration of 60 seconds or less are accepted",
      recommended:
        "It is recommended that the video be no less than 1280x720 and no more than 2560x1440",
      website:
        "The website reserves the right to remove the offending films without notice and reserves the right to pursue relevant matters",
      next: "Next steps",
      Uploadprogress: "Upload Progress",
      thumbnail: "* Video Thumbnail (Max size: 1280*720)",
      custom: "Upload Custom Thumbnails",
      image_yourself: "Upload your own cover image",
      Filename: "File Name",
      Filesize: "File Dimensions",
      File_size: "File Size",
      uploader: "Uploader",
      Uploadtime: "Upload Time",
      Filmtitle: "Movie Title",
      Filmdescription: "Video Description",
      key: "Keywords (separated by ',', no Spaces)",
      eg: "e.g. Happiness, plot, interest...",
      privacy: "Privacy Settings",
      placeholder: "Please Select",
      last: "Last Step",
      Videolink: "Video Link",
      ok: "Accomplish",
      processing: "In Process",
      Tips: "Tips",
      msg2:
        "Please confirm the content. If there is no problem, press the next step. Otherwise, please return to the previous step to modify",
      cancel: "Cancel",
      confirm: "Confirm",
      msg3: "The cover image of the uploaded movie"
    },
    group: {
      detailCard: {
        bookmark: "Bookmark",
        share: "Share",
        flag: "Report",
        EditorialPost: "Edit",
        DeletePost: "Delete"
      },
      groupAccList: {
        search: "Search for user names of existing friends",
        search1: "Searching for a friend list user name",
        search2: "Searching a Friend List",
        Searchresult: "Search Results",
        packup: "Packup",
        unfold: "Unfold",
        Removed: "Remove From Friends List",
        blockFriend: "Blacklist",
        friend: "Friend",
        a: "",
        batchoperation: "Batch Operations"
      },
      groupAddAcc: {
        search_user: "Searching for a User's Name",
        join: "Search for users/groups by name",
        keys: "Keyword",
        placeholder: "Please Select",
        Friendusers: "Friend Users",
        Groupsfriends: "Groups of Friends",
        Searchingfriends: "Searching for Friends",
        searchresult: "Search Results",
        Invite: "Invite",
        Join_: "Join",
        been_invited: "Already invited by me",
        remove: "Remove",
        removedfriend: "Remove a Friend",
        Approve: "Approved as a friend",
        Refuse: "Refuse to be Friends",
        requests: "User applied to join the group",
        application: "Grant the Application",
        rejection: "Refusal of Application",
        admission: "My application status to join the group",
        Unjoin: "Unjoin",
        Applying: "Currently applying to join the group",
        invitedgroup: "Invited to join the group",
        Agreepass: "Agree to Pass",
        Refusepass: "Refuse to Pass",
        requests_: "Inviting Users to the Group",
        Friendstatus: "Friend Status",
        Groupstatus: "Group Status"
      },
      groupBlackList: {
        search_user: "Searching for a user's name",
        Searchingusers: "Searching for Users",
        searchresult: "Search Results",
        packup: "Packup",
        unfold: "Unfold",
        blacklist: "Join the Blacklist",
        masking: "Masking",
        Blockingusers: "Blocking Users",
        a: "",
        batchoperation: "Batch Operations",
        Removedblacklist: "Removed from the Blacklist"
      },
      groupDetail: {
        Reducedpresentation: "Reduced Presentation",
        ShowMore: "Show More",
        placeholder: "Click here to select the date",
        hidden: "Content that has been hidden",
        PhotoAlbumSharing: "Photo Album Sharing",
        ShortVideoSharing: "Short Video Sharing",
        Editing: "Editing",
        delpost: "Delete",
        AddPost: "Add new dynamic",
        FriendsInGroup: "Friends You Know in a Group",
        hiddenpost: "Hide the Post",
        Afterhiding:
          "After hiding the post, only the group owner and themselves can see the content",
        placeholderText: "What do you want to share today?",
        fileupload: "Click to select file upload",
        shortlink: "Enter a short link to a shared album?",
        upload: "Drag the file here, or",
        clickupload: "Click Upload",
        checkupload: "Selected File:",
        type: "Only mp4/mov/mpg/3gp/flv file formats are supported",
        msg:
          "The website reserves the right to remove the offending films without notice and reserves the right to pursue relevant matters",
        msg2: "Video Cover(size not greater than: 1280x720)",
        image: "Upload Cover",
        File_name: "File Name",
        widhei: "Dimensions",
        sgL_Size: "File Size",
        displayName: "Uploader",
        videoCreateTime: "Upload Time",
        videoTitle: "Video Title",
        placeholderTitle: "Maximum of 28 Chinese and English number symbols",
        VideoDescription: "Description",
        keys: `Keywords (separated by "," without Spaces)`,
        eg: "e.g. Happiness, plot, interest...",
        PrivacySettings: "Privacy Settings",
        pleasechoose: "Please Select",
        open: "Public",
        msg3: "Group, only seen by friends in the group",
        NULLOPEN: "Prviate. Only know the link people can be see it.",
        NewPost: "New Post",
        Release: "Release",
        ReportVueTitle: "Title",
        response: "Enter your message...",
        Close: "Cancel",
        OK: "Confirm"
      },
      groupImg: {},
      groupList: {
        search_user: "Searching for a user's name",
        Settinggroups: "Settup Group",
        placeholder: "Please Select",
        Searchinguserlist: "Searching a list of users",
        Searchfriendlist: "Searching your friend list",
        friendlist: "Friends List",
        cancel: "Cancel",
        Invite: "Invite",
        GroupUser: "Group Users",
        a: "",
        Removegroup: "Remove From a Group",
        offsharing: "Turn off Sharing Images",
        Closemessages: "Close Messages",
        rem: "Remove a team Member",
        msg1: "Sharing Images",
        Openmessage: "Open Message",
        Searchingusers: "Searching for Users",
        searchresult: "Search Results",
        packup: "Packup",
        unfold: "Unfold",
        batchoperation: "Batch Operations"
      },
      groupSetting: {
        setGroup: "Settup Group",
        placeholder: "Please Select",
        Groupflags: "Group Cover",
        groupname: "Group Name",
        sgL_GroupName: "The name you display on the group",
        groupdes: "Group introductions",
        sgL_GroupContent: "A short introduction to your group",
        foruserMessage: "Message and Reply",
        OPEN: "On",
        NO_OPEN: "Off",
        Groupvideo: "Group Video",
        Disable: "Disable Group Posting",
        Groupbackground: "Group Background",
        background_color: "Background Color",
        wordcolor: "Text Color",
        Delgroup: "Delete this Group",
        details:
          "Note that all shared content in the main group will be deleted after deletion",
        cancel: "Cancel",
        save: "Save Settings"
      },
      groupuserblacklist: {
        setGroup: "Settup Group",
        placeholder: "Please Select",
        selGroupUserName: "Search for Group User Names",
        searchGroupList: "Searching Group Lists",
        GroupList: "Group List",
        searchGroupUser: "Searching for Group Users",
        searchresult: "Search Results",
        Group_list: "Group List",
        cancel: "Cancel",
        blacklist: "Masking",
        packup: "Packup",
        unfold: "Unfold",
        Blockingusers: "Blocking Users",
        a: "",
        batchoperation: "Batch Operations",
        msg: "Removed From the Blacklist"
      },
      haveGroup: {
        msg: `Drag mouse/finger to the left and select “Leave the group”`,
        Enable: `Shut Down`,
        Leavingroup: `Leave the group`
      },
      index: {
        feedGroup_haveGroup: "Joined Groups",
        feedGroup_groupSetting: "Setting up Group",
        feedGroup_groupList: "Group List",
        feedGroup_userblacklist: "Blacklist"
      }
    },
    friend: {
      index: {
        feedGroup_groupAddAcc: "Add Friends/Groups",
        feedGroup_groupAccList: "Friends List",
        feedGroup_groupBlackList: "Blacklist"
      }
    }
  },
  Video: {
    AboutMovie: {
      RelatedVideos: `Related Videos`
    },
    MoreMovie: {
      MovieList: `Movie List`,
      All: `All`,
      order: `Sort: `,
      Press: `Press last Update`,
      popularity: `By Popularity`
    },
    MoreProgram: {
      Ourshow: `Our Program`,
      All: `All`,
      order: `Sort: `,
      Press: `Press last Update`,
      popularity: `By Popularity`,
      Updated: `Updated to the`,
      episode: `Episode`,
      total: `Total`,
      Lastupdated: `Last Updated:`
    },
    programlist: {
      episodes: `Episodes`
    },
    search: {
      Treasure: `Treasure hunt web search`,
      Topic: `Topic`,
      Activities: `Activities`,
      album: `Album`,
      Video: `Video`,
      Shortvideo: `Short Video`,
      Blog: `Blog`,
      search: `Search`,
      createTime: `Album Creation Time:`,
      searchresult: `Search Results`,
      eventresult: `Event Search Results`,
      searchMore: `Find Out More`,
      albumresult: `Album Search Results`,
      topicresult: `Topic Search Results`,
      videoresult: `Video Search Results`,
      blogresult: `Blog Search Results`,
      storyresult: `Short Video Search Results`
    },
    VideoIndex: {
      EditorChoice: `Editor's Recommend`,
      Ourshow: `Our Program`,
      More: `More`,
      NEW: `Latest Video`,
      showMore: `Show More`
    },
    WatchVideo: {
      Posted: `Posted`,
      bookmark: "Bookmark",
      share: `Share`,
      type: `Type：`,
      keyword: `Keywords`
    }
  },
  ...enLocale
};

export default en;



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js